// list of links that are present in the navbar

export const MenuItems = [
  {
    title: "navbar.menu.home",
    link: "/home",
    cName: "nav-links",
  },
  {
    title: "navbar.menu.contact",
    link: "/contact",
    cName: "nav-links",
  },
  {
    title: "navbar.menu.dashboard",
    link: "/dashboard",
    cName: "nav-links login",
  },
];
